var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const SECTIONS_ORDER = ['personalProperties', 'realEstateDamages', 'totals'];
const HEAD_TYPES = ['header'];
const BODY_TYPES = ['default', 'applied-minimum-charge', 'intermediate-result'];
const FOOT_TYPES = ['footer', 'post-footer'];
let ValuationTable = class ValuationTable extends Vue {
    get orderedSections() {
        var _a;
        if (!((_a = this.valuationData) === null || _a === void 0 ? void 0 : _a.sections))
            return [];
        const entries = Object.entries(this.valuationData.sections);
        return entries.sort(([a], [b]) => SECTIONS_ORDER.indexOf(a) - SECTIONS_ORDER.indexOf(b));
    }
    getHeadRows(section) {
        var _a, _b;
        return ((_b = (_a = section.modes) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.rows.filter((row) => HEAD_TYPES.includes(row.type))) || [];
    }
    getBodyRows(section) {
        var _a, _b;
        const rows = ((_b = (_a = section.modes) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.rows.filter((row) => BODY_TYPES.includes(row.type))) || [];
        if (this.hidePersonalProperties) {
            return rows.filter((row) => !row.cells.some((cell) => { var _a; return (_a = cell.name) === null || _a === void 0 ? void 0 : _a.startsWith('totals-section.personal-properties'); }));
        }
        return rows;
    }
    getFootRows(section) {
        var _a, _b;
        return ((_b = (_a = section.modes) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.rows.filter((row) => FOOT_TYPES.includes(row.type))) || [];
    }
    getRowClass(row) {
        return [
            'valuation-table__row',
            `valuation-table__row--${row.type}`,
            {
                'valuation-table__row--excluded': this.hasExclusionReason(row),
            },
        ];
    }
    getCellClass(cell) {
        var _a;
        return [
            'valuation-table__cell',
            `valuation-table__cell--${cell.type}`,
            {
                'valuation-table__cell--numeric': [
                    'damage.quantity',
                    'damage.valuation.replacement',
                    'valuation.total',
                ].includes((_a = cell.data) === null || _a === void 0 ? void 0 : _a.columnName),
                'valuation-table__cell--grand-total': cell.name === 'totals-section.valuation.final.total',
                'has-text-danger': cell.name === 'totals-section.compensation.labor.and.material.amounts.comment.value',
                'valuation-table__cell--no-wrap': cell.name === 'totals-section.compensation.labor.and.material.amounts.comment.value',
            },
        ];
    }
    hasExclusionReason(row) {
        return row.cells.some((cell) => !!cell.data.exclusionReason);
    }
    get hidePersonalProperties() {
        return insurerHasFeature(InsurerFeatureFlag.HidePersonalProperties, this.trigram);
    }
    get displayedSections() {
        return this.orderedSections.filter(([name, section]) => {
            var _a, _b, _c;
            if (name === 'personalProperties' && this.hidePersonalProperties)
                return false;
            return !!((_c = (_b = (_a = section === null || section === void 0 ? void 0 : section.modes) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.rows) === null || _c === void 0 ? void 0 : _c.length);
        });
    }
};
__decorate([
    Prop({
        type: String,
        required: true,
        validator: (value) => ['self-repair', 'pecuniary'].includes(value),
    })
], ValuationTable.prototype, "name", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ValuationTable.prototype, "selfRepairDiscouraged", void 0);
__decorate([
    Prop({ type: Object, default: null })
], ValuationTable.prototype, "valuationData", void 0);
__decorate([
    claim.Getter('typeTrigram')
], ValuationTable.prototype, "trigram", void 0);
ValuationTable = __decorate([
    Component
], ValuationTable);
export default ValuationTable;
